import React from 'react';
import { Link } from 'react-router-dom';

export default function ComeFunziona() {
  const steps = [
    { num: '01', title: 'Registrazione Gratuita', desc: 'Crea il tuo account in meno di 2 minuti. Inserisci email e password, e il gioco e fatto. Nessun costo, nessun impegno, nessuna carta di credito.', icon: '&#128221;' },
    { num: '02', title: 'Completa il Profilo Aziendale', desc: 'Inserisci i dati della tua azienda: ragione sociale, P.IVA, settore di attivita, regione, fatturato e numero di dipendenti. Piu informazioni fornisci, piu preciso sara il matching.', icon: '&#127970;' },
    { num: '03', title: 'Carica la Visura Camerale', desc: 'Carica la visura camerale in formato PDF. La nostra intelligenza artificiale analizzerà automaticamente il documento per estrarre informazioni chiave e suggerire gli incentivi piu adatti.', icon: '&#128196;' },
    { num: '04', title: 'Matching Automatico', desc: 'Il nostro algoritmo confronta il profilo della tua azienda con il database di oltre 75 incentivi attivi, calcolando una percentuale di compatibilita per ciascuno.', icon: '&#129302;' },
    { num: '05', title: 'Report Personalizzato', desc: 'Ricevi un report PDF completo con tutti gli incentivi compatibili, le percentuali di agevolazione, gli importi massimi e le scadenze. Il report include anche i prossimi passi da seguire.', icon: '&#128202;' },
    { num: '06', title: 'Consulenza Dedicata', desc: 'Il nostro team di esperti e a disposizione per guidarti nella presentazione delle domande e massimizzare le possibilita di successo.', icon: '&#129309;' },
  ];

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="container">
          <h1>Come Funziona</h1>
          <p>Scopri il processo semplice e veloce per trovare gli incentivi per la tua azienda</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {steps.map((step, i) => (
            <div key={i} style={{ display: 'flex', gap: 24, marginBottom: 40, alignItems: 'flex-start', flexWrap: 'wrap' }}>
              <div style={{ width: 80, height: 80, borderRadius: '50%', background: i % 2 === 0 ? 'linear-gradient(135deg, #1a56db, #3b82f6)' : 'linear-gradient(135deg, #16a34a, #22c55e)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: 32, flexShrink: 0 }} dangerouslySetInnerHTML={{ __html: step.icon }} />
              <div style={{ flex: 1, minWidth: 250 }}>
                <div style={{ fontSize: 13, color: '#1a56db', fontWeight: 700, marginBottom: 4 }}>PASSO {step.num}</div>
                <h3 style={{ fontSize: 20, marginBottom: 8 }}>{step.title}</h3>
                <p style={{ color: '#6b7280', lineHeight: 1.7 }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="section" style={{ background: '#f0fdf4', textAlign: 'center' }}>
        <div className="container">
          <h2 className="section-title">Pronto per Iniziare?</h2>
          <p className="section-subtitle">Registrati gratuitamente e scopri subito gli incentivi per la tua azienda</p>
          <Link to="/register" className="btn btn-lg btn-green">Registrati Gratis</Link>
        </div>
      </section>
    </div>
  );
}
